module.exports = __webpack_public_path__ + "img/discount.28e859d3.svg";